var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "paging" }, [
    _c(
      "div",
      { staticClass: "flex-row justify-center" },
      [
        _vm.pagingData.hasPrevious
          ? _c(
              "button",
              {
                staticClass: "flex-col pagebtn",
                on: {
                  click: function ($event) {
                    return _vm.prevPage()
                  },
                },
              },
              [_vm._v(" < ")]
            )
          : _vm._e(),
        _vm.showFirstPage
          ? _c(
              "button",
              {
                staticClass: "flex-col pagebtn",
                on: {
                  click: function ($event) {
                    return _vm.setCurrentPage(1)
                  },
                },
              },
              [_vm._v(" 1 ")]
            )
          : _vm._e(),
        _vm.showStartEllipses
          ? _c("span", { staticClass: "flex-col pagebtn" }, [_vm._v(" ... ")])
          : _vm._e(),
        _vm._l(_vm.pagingData.prevArray, function (num, i) {
          return _c(
            "button",
            {
              key: _vm.prev(i),
              staticClass: "flex-col pagebtn",
              on: {
                click: function ($event) {
                  return _vm.setCurrentPage(_vm.pagingData.prevArray[i])
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.pagingData.prevArray[i]) + " ")]
          )
        }),
        _c("div", { staticClass: "flex-col pagebtn" }, [
          _vm._v(" " + _vm._s(_vm.pagingData.currentPage) + " "),
        ]),
        _vm._l(_vm.pagingData.afterArray, function (num, j) {
          return _c(
            "button",
            {
              key: _vm.nxt(j),
              staticClass: "flex-col pagebtn",
              on: {
                click: function ($event) {
                  return _vm.setCurrentPage(_vm.pagingData.afterArray[j])
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.pagingData.afterArray[j]) + " ")]
          )
        }),
        _vm.showEndEllipses
          ? _c("span", { staticClass: "flex-col pagebtn" }, [_vm._v(" ... ")])
          : _vm._e(),
        _vm.showLastPage
          ? _c(
              "button",
              {
                staticClass: "flex-col pagebtn",
                on: {
                  click: function ($event) {
                    return _vm.setCurrentPage(_vm.pagingData.totalPageCount)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.pagingData.totalPageCount) + " ")]
            )
          : _vm._e(),
        _vm.pagingData.hasNext
          ? _c(
              "button",
              {
                staticClass: "flex-col pagebtn",
                on: {
                  click: function ($event) {
                    return _vm.nextPage()
                  },
                },
              },
              [_vm._v(" > ")]
            )
          : _vm._e(),
      ],
      2
    ),
    _c("div", { staticClass: "flex-row flex-1 mt-2" }, [
      _c("div", { staticClass: "flex-col flex-1" }, [_vm._t("pageContent")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }